<template lang="pug">
  main
    NavBarMonitor
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container.is-fluid
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title  Monitoreo &nbsp
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-full.has-text-centered
            .tabs.is-centered
              ul
                li(:class="{ 'is-active': tabsel == 'tpa-llen' }" @click="cambiarTab('tpa-llen')" v-show="verTPA")
                  a
                    span LLenaderas TPA
                li(:class="{ 'is-active': tabsel == 'tpa_esferas' }" @click="cambiarTab('tpa_esferas')" v-show="verTPA || verTPA_Esf")
                  a
                    span.icon.is-small
                      i.fas.fa-circle-notch(aria-hidden='true')
                    span Esferas TPA
                li(:class="{ 'is-active': tabsel == 'tpa_muelle' }" @click="cambiarTab('tpa_muelle')" v-show="verTPA || verMuelle")
                  a
                    span Muelle TPA
                li(:class="{ 'is-active': tabsel == 'irge_llen' }" @click="cambiarTab('irge_llen')" v-show="verIRGE_Llen")
                  a
                    span ️Llenaderas IRGE
                li(:class="{ 'is-active': tabsel == 'irge_esferas' }" @click="cambiarTab('irge_esferas')" v-show="verIRGE_Esf")
                  a
                    span.icon.is-small
                      i.fas.fa-circle-notch(aria-hidden='true')
                    span Esferas IRGE
                li(:class="{ 'is-active': tabsel == 'eb00_patin' }" @click="cambiarTab('eb00_patin')" v-show="verPatin || verPatinEB00")
                  a
                    span EB00 Patín PM100
                li(:class="{ 'is-active': tabsel == 'eb04_patin' }" @click="cambiarTab('eb04_patin')" v-show="verPatin || verPatinEB04")
                  a
                    span EB04 Patín
                li(:class="{ 'is-active': tabsel == 'valvulas' }" @click="cambiarTab('valvulas')" v-show="verValvulas")
                  a
                    span Válvulas
        .columns
          .column.is-full
            Llenaderas_TPA(v-show="watch_Monitor==='tpa-llen'" :activo="act_TPA_llenaderas" :permisos="permisos.monitoreo")
            Esferas_TPA(v-show="watch_Monitor==='tpa_esferas'" :activo="act_TPA_esferas")
            Muelle_TPA(v-show="watch_Monitor==='tpa_muelle'" :activo="act_TPA_muelle" :verHistoria="verHistoria")
            PatinPM100(v-show="watch_Monitor==='eb00_patin'" :activo="act_EB00_patin")
            PatinEB04(v-show="watch_Monitor==='eb04_patin'" :activo="act_EB04_patin")
            Valvulas(v-show="watch_Monitor==='valvulas'" :activo="act_valvulas")
            Llenaderas_IRGE(v-show="watch_Monitor==='irge_llen'" :activo="act_IRGE_llenaderas" :permisos="permisos.monitoreo")
            Esferas_IRGE(v-show="watch_Monitor==='irge_esferas'" :activo="act_IRGE_esferas")
        .columns.column-blanco
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarMonitor from '@/components/estaciones_Componentes/NavBarMonitor.vue'
import { mapState } from 'vuex'
import PatinPM100 from '@/components/estaciones_Componentes/PatinPM100.vue'
import PatinEB04 from '@/components/estaciones_Componentes/PatinEB04.vue'
import Valvulas from '@/components/estaciones_Componentes/Valvulas.vue'
import Llenaderas_IRGE from '@/components/estaciones_Componentes/Llenaderas_IRGE.vue'
import Esferas_IRGE from '@/components/estaciones_Componentes/Esferas_IRGE.vue'
import Llenaderas_TPA from '@/components/estaciones_Componentes/Llenaderas_TPA.vue'
import Esferas_TPA from '@/components/estaciones_Componentes/Esferas_TPA.vue'
import Muelle_TPA from '@/components/estaciones_Componentes/Muelle_TPA.vue'
import monitorServices from '@/services/sca/monitor'


export default {
  name: 'Monitor',
  components: { Loader, NavBarMonitor, PatinPM100, PatinEB04, Valvulas, Llenaderas_IRGE, Esferas_IRGE, Llenaderas_TPA, Esferas_TPA, Muelle_TPA },
  data () {
    return {
      isLoading: true,
      tabsel: '',
      watch_Monitor: '',
      verTPA: false,
      verPatin: false,
      verPatinEB00: false,
      verPatinEB04: false,
      verValvulas: false,
      verIRGE_Llen: false,
      verIRGE_Esf: false,
      verTPA_Esf: false,
      verMuelle: false,
      act_TPA_llenaderas: false,
      act_TPA_esferas: false,
      act_IRGE_llenaderas: false,
      act_IRGE_esferas: false,
      act_TPA_muelle: false,
      act_EB00_patin: false,
      act_EB04_patin: false,
      act_valvulas: false,
      fileEDA: {},
      verHistoria: false,
    }
  },
  methods: {
    iniciarComponente () {
      this.obtenerUser()
      if (this.permisos.monitoreo == 1) {
        switch (this.estacionSel) {
          case 'TPA':
            this.tabsel = 'tpa-llen'
            this.watch_Monitor = 'tpa-llen'
            this.verTPA = true
            break
          case 'IRGE':
            if (this.userLogin.id_oficina == 30 && this.userLogin.cargo === '001') {
              this.tabsel = 'valvulas'
              this.act_valvulas = true
              this.isDucto = true
              this.watch_Monitor = 'valvulas'
              this.act_valvulas = true
              this.verValvulas = true
              this.verPatin = true
              this.verPatinEB04 = true
              this.verIRGE_Llen = true
              this.verIRGE_Esf = true
            } else {
              this.tabsel = 'irge_llen'
              this.watch_Monitor = 'irge_llen'
              this.act_valvulas = true
              this.verIRGE_Llen = true
              this.verIRGE_Esf = true
            }
            break
          case 'DUCTO':
            this.tabsel = 'valvulas'
            this.watch_Monitor = 'valvulas'
            this.act_valvulas = true
            this.verValvulas = true
            this.verPatin = true
            this.verPatinEB04 = true
            if (this.userLogin.ubicacion === 'EB04') {
              this.verIRGE_Llen = true
              this.verIRGE_Esf = true
            }
            break
          default:
            this.watch_Monitor = 'valvulas'
            this.act_valvulas = true
            this.tabsel = 'valvulas'
            this.verTPA = false
            this.verValvulas = false
            this.verPatin = false
            this.verIRGE_Llen = false
            this.verIRGE_Esf = false

            break
        }
        this.verHistoria = true
      } else {
        this.checkPermisos()
      }
    },
    obtenerUser() {
      if (!this.userLogin.success) {
        this.$router.push('/')
      }
      this.isLoading = false
    },

    cambiarTab (tab) {
      this.watch_Monitor = tab
      this.tabsel = tab
      switch (tab) {
        case 'tpa-llen':
          this.act_TPA_llenaderas = true
          this.act_TPA_esferas = false
          this.act_TPA_muelle = false
          this.act_IRGE_llenaderas = false
          this.act_IRGE_esferas = false
          this.act_EB00_patin = false
          this.act_EB04_patin = false
          this.act_valvulas = false
          break
        case 'tpa_esferas':
          this.act_TPA_llenaderas = false
          this.act_TPA_esferas = true
          this.act_TPA_muelle = false
          this.act_IRGE_llenaderas = false
          this.act_IRGE_esferas = false
          this.act_EB00_patin = false
          this.act_EB04_patin = false
          this.act_valvulas = false
          break
        case 'tpa_muelle':
          this.act_TPA_llenaderas = false
          this.act_TPA_esferas = false
          this.act_TPA_muelle = true
          this.act_IRGE_llenaderas = false
          this.act_IRGE_esferas = false
          this.act_EB00_patin = false
          this.act_EB04_patin = false
          this.act_valvulas = false
          break
        case 'irge_llen':
          this.act_TPA_llenaderas = false
          this.act_TPA_esferas = false
          this.act_TPA_muelle = false
          this.act_IRGE_llenaderas = true
          this.act_IRGE_esferas = false
          this.act_EB00_patin = false
          this.act_EB04_patin = false
          this.act_valvulas = false
          break
        case 'irge_esferas':
          this.act_TPA_llenaderas = false
          this.act_TPA_esferas = false
          this.act_TPA_muelle = false
          this.act_IRGE_llenaderas = false
          this.act_IRGE_esferas = true
          this.act_EB00_patin = false
          this.act_EB04_patin = false
          this.act_valvulas = false
          break
        case 'eb00_patin':
          this.act_TPA_llenaderas = false
          this.act_TPA_esferas = false
          this.act_TPA_muelle = false
          this.act_IRGE_llenaderas = false
          this.act_IRGE_esferas = false
          this.act_EB00_patin = true
          this.act_EB04_patin = false
          this.act_valvulas = false
          break
        case 'valvulas':
          this.act_TPA_llenaderas = false
          this.act_TPA_esferas = false
          this.act_TPA_muelle = false
          this.act_IRGE_llenaderas = false
          this.act_IRGE_esferas = false
          this.act_EB00_patin = false
          this.act_EB04_patin = false
          this.act_valvulas = true
          break
        case 'eb04_patin':
          this.act_TPA_llenaderas = false
          this.act_TPA_esferas = false
          this.act_TPA_muelle = false
          this.act_IRGE_llenaderas = false
          this.act_IRGE_esferas = false
          this.act_EB00_patin = false
          this.act_EB04_patin = true
          this.act_valvulas = false
          break
        default:
          this.act_TPA_llenaderas = false
          this.act_TPA_esferas = false
          this.act_TPA_muelle = false
          this.act_IRGE_llenaderas = false
          this.act_IRGE_esferas = false
          this.act_EB00_patin = false
          this.act_EB04_patin = false
          this.act_valvulas = false

          break
      }
    },
    backPage() {
      this.$router.back()
    },

    checkPermisos() {
      if (this.permisos) {
        switch (this.permisos.monitoreo) {
          case 1:
            this.watch_Monitor = 'valvulas'
            this.tabsel = 'valvulas'
            this.verTPA = true
            this.verPatin = true
            this.verValvulas = true
            this.verIRGE_Llen = true
            this.verIRGE_Esf = true
            return
          case 2:
            return
          case 3:
            this.watch_Monitor = 'tpa-llen'
            this.tabsel = 'tpa-llen'
            this.verTPA = true
            return
          case 4:
            this.watch_Monitor = 'irge_llen'
            this.tabsel = 'irge-llen'
            this.verIRGE_Llen = true
            this.verIRGE_Esf = true
            return
          case 5:
            this.watch_Monitor = 'valvulas'
            this.tabsel = 'valvulas'
            this.verPatin = true
            this.verValvulas = true
            return
          case 6:
            this.watch_Monitor = 'valvulas'
            this.tabsel = 'valvulas'
            this.verPatin = true
            this.verValvulas = true
            this.verTPA = true
            return
          case 7:
            this.watch_Monitor = 'valvulas'
            this.tabsel = 'valvulas'
            this.verPatin = true
            this.verValvulas = true
            this.verIRGE_Esf = true
            return
          case 8:
            this.watch_Monitor = 'valvulas'
            this.tabsel = 'valvulas'
            this.verPatin = true
            this.verValvulas = true
            this.verIRGE_Esf = true
            this.verIRGE_Llen = true
            return
          case 9:
            this.watch_Monitor = 'tpa_esferas'
            this.tabsel = 'tpa_esferas'
            this.verPatin = true
            this.verPatinEB00 = true
            this.verIRGE_Esf = true
            this.verTPA_Esf = true
            this.verMuelle = true
            return
          case 10:
            this.watch_Monitor = 'tpa_esferas'
            this.tabsel = 'tpa_esferas'
            this.verTPA = true
            this.verPatin = true
            this.verPatinEB00 = true
            this.verIRGE_Esf = true
            this.verTPA_Esf = true
            this.verIRGE_Llen = true
            this.verMuelle = true
            return
          case 11:
            this.watch_Monitor = 'tpa-llen'
            this.tabsel = 'tpa-llen'
            this.verTPA = true
            this.verHistoria = true
          case 12:
            this.watch_Monitor = 'tpa-llen'
            this.tabsel = 'tpa-llen'
            this.verTPA = true
            this.verHistoria = true
            return
        }
      }
    },

  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'estacionSel', 'permisos'])
  },
  created () {
    this.iniciarComponente()
  }
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 50px;
  }

  .section{
      padding: 3rem 1.5rem;
    }

  .tabs ul {
    border-bottom-color: inherit;
    border-bottom-style: solid;
    border-bottom-width: 0;
  }

  .is-active {
    border-bottom-color: #3273dc;
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  @media (min-width:320px) and (max-width: 480px) {
    .section{
      padding: 3rem 0.5rem;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/estaciones_Componentes/Monitor.vue